import { useIsResultTabView } from "../components/SearchContextProvider";
import { REFINEMENT_EXCLUDED_ATTRIBUTES } from "../constants";
const useRefinementExcludedAttributes = () => {
  const { isResultTabView } = useIsResultTabView();
  if (!isResultTabView) {
    return REFINEMENT_EXCLUDED_ATTRIBUTES;
  } else {
    return REFINEMENT_EXCLUDED_ATTRIBUTES.filter((excludedItem) => {
      return excludedItem !== "product";
    });
  }
};

export default useRefinementExcludedAttributes;
